var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChaine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1029 5.50297C16.0402 4.56571 17.5598 4.56571 18.497 5.50297C19.4343 6.44023 19.4343 7.95982 18.497 8.89708L14.897 12.4971C13.9598 13.4343 12.4402 13.4343 11.5029 12.4971C11.0343 12.0285 10.2745 12.0285 9.80586 12.4971C9.33723 12.9657 9.33723 13.7255 9.80586 14.1941C11.6804 16.0687 14.7196 16.0687 16.5941 14.1941L20.1941 10.5941C22.0686 8.71962 22.0686 5.68043 20.1941 3.80591C18.3196 1.9314 15.2804 1.9314 13.4059 3.80591L11.6059 5.60591C11.1372 6.07454 11.1372 6.83434 11.6059 7.30297C12.0745 7.7716 12.8343 7.7716 13.3029 7.30297L15.1029 5.50297Z",
    fill: "#4318FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10294 11.503C10.0402 10.5657 11.5598 10.5657 12.4971 11.503C12.9657 11.9716 13.7255 11.9716 14.1941 11.503C14.6627 11.0343 14.6627 10.2745 14.1941 9.80591C12.3196 7.9314 9.2804 7.9314 7.40588 9.80591L3.80588 13.4059C1.93136 15.2804 1.93136 18.3196 3.80588 20.1941C5.6804 22.0687 8.71959 22.0687 10.5941 20.1941L12.3941 18.3941C12.8627 17.9255 12.8627 17.1657 12.3941 16.6971C11.9255 16.2285 11.1657 16.2285 10.6971 16.6971L8.89705 18.4971C7.95979 19.4343 6.4402 19.4343 5.50294 18.4971C4.56568 17.5598 4.56568 16.0402 5.50294 15.103L9.10294 11.503Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaine);
export default __webpack_public_path__ + "static/media/chaine.4d8cfc41d7a109de721dd3423bd4bf7a.svg";
export { ForwardRef as ReactComponent };